import { Component } from '@angular/core';
import {Router, NavigationError, NavigationEnd, NavigationStart, NavigationCancel} from '@angular/router';
import { isNullOrUndefined } from 'src/app/helpers/tools';
import {firstValueFrom} from 'rxjs/internal/firstValueFrom';
import {RaygunService} from "./shared/services/raygun.service";
import {ServerHubSignalR} from "./shared/services/serverHub.signalR";
import {ProgressBannerService} from "./shared/services/progress-banner.service";
import {StyleService} from "./shared/components/style/style.service";
import {ErrorCodeService} from "./shared/services/error-code.service";
import {RouteTrackerService} from "./shared/services/route-tracker.service";
import {RouteLoadingService} from "./shared/services/route-loading.service";
import {Location} from "@angular/common";
import {LoginServerService} from "./layouts/public/login/services/login-server.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent {
    title = 'app';
    private timer: any;

    constructor(private router: Router, private _raygunService: RaygunService,
        private serverHubSignalR: ServerHubSignalR, private _styleService: StyleService, 
        private _progressBannerService: ProgressBannerService, private _errorCodeService: ErrorCodeService,
        private _routeTracker: RouteTrackerService, private _routeLoading: RouteLoadingService, private _location: Location,
        private _loginService: LoginServerService) {

        serverHubSignalR.setup();

        _progressBannerService.setup();
        
        this.router.events.subscribe(event => {
            if (event) {
                if (event instanceof  NavigationStart) {
                    this._routeTracker.addRouteToHistory(event.url);
                } else if (event instanceof NavigationEnd) {
                    this._routeTracker.addRouteToHistory(event.urlAfterRedirects);
                    window.scrollTo(0, 0);
                    // Remove old page-location class
                    var classList = $("body").attr("class");
                    if (classList) {
                        var locClasses = classList.split(" ").filter(x => x.includes("page-location-"));
                        if (locClasses && locClasses.length >= 1) {
                            for (let i = 0; i < locClasses.length; i++) {
                                $("body").removeClass(locClasses[i]);
                            }
                        }
                    }
                    // Add new page-location class
                    var newClass = event.urlAfterRedirects.split("/").filter(x => x != "");
                    if (this.errorCode) {
                        newClass = ["error"];
                    }
                    if (newClass) {
                        $("body").addClass(`page-location-${newClass[0].split("?")[0]}`);
                    }
                    this._raygunService.trackEvent(event);
                
                } else if (event instanceof NavigationError) {
                    this._raygunService.sendEvent(event);
                }
            }
            
            if (event instanceof NavigationStart) {
                this.timer = setTimeout(() => {
                    this._routeLoading.loadingRoute = event.url;
                }, 200);
            } else if (
                event instanceof NavigationEnd ||
                event instanceof NavigationCancel ||
                event instanceof NavigationError
            ) {
                clearTimeout(this.timer);
                this._routeLoading.loadingRoute = null;
            }
        });
    }
    
    public async ngOnInit() {
    }
    
    public get errorCode() {
        return this._errorCodeService.errorCode;
    }
    
    public get showFullSpinner() {
        return this._loginService.isChangingAccount;
    }
}
